import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import tapEvent, { FooterAction } from 'lib/Tracking/Footer/TapEvent';
import useEvents from 'lib/hooks/useEvents';
import { SourcePages } from 'lib/EventSchema';
import Link, { css } from './Link';

const LINKS = Object.freeze([
  {
    href: '/about-us',
    title: 'footer.about',
    trackingSection: 'about',
    testId: 'footer-about-link',
  },
  {
    href: '/news-and-analysis',
    title: 'header.newsAndAnalysis',
    trackingSection: 'news_and_analysis',
    testId: 'footer-news-analysis-link',
  },
  {
    href: '/guides',
    title: 'header.guidesAndReviews',
    trackingSection: 'guides_and_reviews',
    testId: 'footer-guides-link',
  },
]);

interface CompanyLinksProps {
  className: string;
}

export default function CompanyLinks({ className }: CompanyLinksProps): JSX.Element {
  const { t } = useTranslation();
  const logger = useEvents();
  const { asPath } = useRouter();

  function logFooterTapEvent(action: FooterAction): void {
    logger.log(tapEvent({ action, pathName: asPath as SourcePages }));
  }

  return (
    <ul className={`links ${className}`} role="navigation">
      {LINKS.map(({ href, title, trackingSection, testId }) => (
        <li key={title}>
          <Link
            href={href}
            onClick={(): void => {
              logFooterTapEvent(trackingSection as FooterAction);
            }}
            className="footer-company-link"
            anchorProps={{ 'data-testid': testId }}
          >
            {t(title)}
          </Link>
        </li>
      ))}
      <li>
        <Link
          href="/help"
          onClick={(): void => {
            logFooterTapEvent('contact');
          }}
          className={`footer-company-link ${css.className}`}
        >
          {t('footer.contact')}
        </Link>
      </li>
      <style jsx>
        {`
          .footer-company-link {
            font-weight: 300;
          }
          .links {
            width: 100%;
            list-style: none;
            padding: 0;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            padding: 0px 0px 0px 0px;
            margin-bottom: 0;
            grid-template-rows: 0.1fr 0.1fr 0.1fr 0.1fr;
          }
        `}
      </style>
      {css.styles}
    </ul>
  );
}
